import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Dialog,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
  DialogActions,
  TextField,
  CardContent,
  Divider,
  Radio,
  RadioGroup,
  FormControlLabel,
  Switch,
  Checkbox,
  Stack,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { RxCross2 } from "react-icons/rx";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  createJewellerRequest,
  editJewellerRequest,
  resetJewellerMessages,
  fetchInstalaxmiUsersRequest,
} from "../../../redux/JewellerList/JewellerSlice";
import CreateJwellerTable from "../CreateJweller/CreateJwellerTable";
import { toast } from "react-toastify";
import { getActiveCountriesRequest } from "../../../redux/CountryList/CountrySlice";
import auth from "../../../configs/auth";
import { allCountries } from "./allCountries";
import { width } from "@mui/system";
import { canShowPermission } from "../Permissions/permissionObject";
import { fetchInstalaxmiAdminRequest } from "../../../redux/Tickets/ticketSlice";
import { fetchPlansRequest } from "../../../redux/sagas/Subscription/SubscriptionSlice";
import { getBenefitsAndFeatures } from "../../../redux/Configuration/configurationSlice";
import {
  subscriptionFrequency,
  benefitFields,
  CalculationType,
} from "../../../configs/constants";
import {
  clearCouponError,
  clearCouponInfo,
  getApplicableCouponsRequest,
} from "../../../redux/sagas/Coupon/CouponSlice";

const VALIDITY_LABELS = {
  daily: "Daily",
  weekly: "Weekly",
  biweekly: "Biweekly",
  monthly: "Monthly",
  quarterly: "Quarterly",
  half_yearly: "Half yearly",
  yearly: "Yearly",
};

const formatInr = (value) =>
  `₹${Number(value || 0).toLocaleString("en-IN", {
    maximumFractionDigits: 2,
  })}`;

const toBenefitPayload = (benefits) =>
  (Array.isArray(benefits) ? benefits : []).map((item) => ({
    key: item.key,
    label: item.label || "",
    restricted: Boolean(item.restricted),
    value: item.restricted ? Number(item.value) || 0 : 0,
    description: item.description || "",
  }));

const sectionCardSx = {
  mx: 2,
  mt: 2,
  p: { xs: 2, md: 2.5 },
  border: "1px solid #E7E7F0",
  borderRadius: "12px",
  background: "#fff",
};

const SectionHeading = ({ step, title, description }) => (
  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, mb: 2 }}>
    <Box
      sx={{
        width: 28,
        height: 28,
        mt: "2px",
        borderRadius: "50%",
        background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        fontSize: 13,
        flexShrink: 0,
      }}
    >
      {step}
    </Box>
    <Box>
      <Typography fontWeight={700} fontSize={18} fontFamily="Aeonik">
        {title}
      </Typography>
      {description ? (
        <Typography variant="body2" color="text.secondary" mt={0.5}>
          {description}
        </Typography>
      ) : null}
    </Box>
  </Box>
);

const initialJeweller = {
  jewellerName: "",
  email: "",
  phone: "",
  countryCode: "",
  identity: "Gst",
  cluster: "cluster-1",
  package_name: "",
  package_name_ios: "",
  //directors: [{ name: "", email: "", phone: "" }],
  // signatories: [{ name: "", email: "", phone: "" }],
  address: [
    {
      address1: "",
      address2: "",
      address3: "",
      Area: "",
      city: "",
      pincode: "",
      state: "",
    },
  ],
};

const defaultCustomBenefits = () =>
  (Array.isArray(benefitFields) ? benefitFields : []).map((item) => ({
    ...item,
  }));

const JewellerFormFrame = ({ pageMode, open, onClose, children }) => {
  if (pageMode) {
    return (
      <Box
        sx={{
          width: "100%",
          mt: { xs: 10, md: 10 },
          mb: 2,
          background: "#fff",
          borderRadius: "3px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      PaperProps={{ sx: { borderRadius: "3px" } }}
    >
      {children}
    </Dialog>
  );
};

const CreateJwellerList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const fromLead = Boolean(
    location.state?.openJewellerForm && location.state?.lead,
  );
  const [open, setOpen] = useState(false);
  const [subscriptionMode, setSubscriptionMode] = useState(
    fromLead ? "custom" : "existing",
  );
  const [selectedPlanId, setSelectedPlanId] = useState("");
  const [customPlan, setCustomPlan] = useState({
    amount: "",
    validity: "",
    features: [],
    benefits: defaultCustomBenefits(),
  });
  const [paidAmount, setPaidAmount] = useState("");
  const [tdsAmount, setTdsAmount] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [couponInfo, setCouponInfo] = useState(null);
  const [didVerifyCoupon, setDidVerifyCoupon] = useState(false);
  const jewellerList = useSelector((state) => state.jeweller.jewellers);
  const dispatch = useDispatch();
  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [selectedPhoneLength, setSelectedPhoneLength] = useState(10);
  const [selectedDialCode, setSelectedDialCode] = useState("+91");
  const [filteredStates, setFilteredStates] = useState([]);
  const [formData, setFormData] = useState({
    data: {
      enrichedJewellers: [initialJeweller],
    },
  });
  const [selectedInstalaxmiUser, setSelectedInstalaxmiUser] = useState("");
  const [newComment, setNewComment] = useState("");
  const instalaxmiUsersFromJeweller = useSelector(
    (state) => state.jeweller.instalaxmiUsers,
  );
  const instalaxmiAdminList = useSelector(
    (state) => state.tickets?.instalaxmiAdmin,
  );
  const instalaxmiUsers = (
    Array.isArray(instalaxmiAdminList) && instalaxmiAdminList.length
      ? instalaxmiAdminList
      : Array.isArray(instalaxmiUsersFromJeweller)
        ? instalaxmiUsersFromJeweller
        : []
  );
  console.log("instalaxmiUsers", instalaxmiUsers);

  const { activeCountries = [] } = useSelector((state) => state.country || {});
  const jeweller = sessionStorage.getItem(auth.selectedJeweller);
  const subscriptionPlans = useSelector(
    (state) => state.subscriptionPlan?.data || [],
  );
  const benefitsData = useSelector(
    (state) => state?.appConfig?.benefitsAndFeatures?.benefitFields || [],
  );
  const featuresData = useSelector(
    (state) => state?.appConfig?.benefitsAndFeatures?.FeatureOptions || {},
  );
  const featureChoices = Object.values(featuresData || {});
  const reduxCouponInfo = useSelector((state) => state.coupon?.coupon_info || {});
  const couponError = useSelector((state) => state.coupon?.error);
  const benefitsSeeded = useRef(false);

  useEffect(() => {
    dispatch(getActiveCountriesRequest({ jeweller }));
    dispatch(fetchInstalaxmiUsersRequest());
    dispatch(fetchInstalaxmiAdminRequest());
  }, [dispatch]);

  useEffect(() => {
    if (!open || isEditMode) return;
    dispatch(fetchPlansRequest({ page: 1, limit: 200 }));
    dispatch(getBenefitsAndFeatures());
  }, [open, isEditMode, dispatch]);

  useEffect(() => {
    if (!open || isEditMode) {
      benefitsSeeded.current = false;
      return;
    }
    if (benefitsSeeded.current) return;
    if (!Array.isArray(benefitsData) || benefitsData.length === 0) return;
    benefitsSeeded.current = true;
    setCustomPlan((prev) => ({
      ...prev,
      benefits: benefitsData.map((item) => ({ ...item })),
    }));
  }, [open, isEditMode, benefitsData]);

  useEffect(() => {
    if (!didVerifyCoupon) return;

    if (couponError) {
      toast.error(couponError);
      setCouponInfo(null);
      setDidVerifyCoupon(false);
      dispatch(clearCouponError());
      return;
    }

    if (reduxCouponInfo && Object.keys(reduxCouponInfo).length > 0) {
      setCouponInfo(reduxCouponInfo);
      setDidVerifyCoupon(false);
      toast.success("Coupon applied");
    }
  }, [reduxCouponInfo, couponError, didVerifyCoupon, dispatch]);

  const { message, messageType } = useSelector((state) => state.jeweller);

  useEffect(() => {
    if (message && messageType) {
      if (messageType === "error") {
        toast.error(message);
      } else if (messageType === "success") {
        toast.success(message);
      }

      dispatch(resetJewellerMessages());
    }
  }, [message, messageType, dispatch]);

  const resetSubscriptionForm = (mode = "existing") => {
    setSubscriptionMode(mode);
    setSelectedPlanId("");
    setCustomPlan({
      amount: "",
      validity: "",
      features: [],
      benefits:
        Array.isArray(benefitsData) && benefitsData.length
          ? benefitsData.map((item) => ({ ...item }))
          : defaultCustomBenefits(),
    });
    setPaidAmount("");
    setTdsAmount("");
    setCouponCode("");
    setCouponInfo(null);
    setDidVerifyCoupon(false);
    dispatch(clearCouponError());
    dispatch(clearCouponInfo());
  };

  const openCreateFromLead = (lead) => {
    if (!lead) return;
    const countryId =
      (lead.countryCode && typeof lead.countryCode === "object"
        ? lead.countryCode._id
        : lead.countryCode) || "";
    const prefilled = {
      ...JSON.parse(JSON.stringify(initialJeweller)),
      jewellerName: lead.jewellerName || "",
      email: lead.email || "",
      phone: lead.phone || lead.contactNumber || "",
      countryCode: countryId,
      RM: Array.isArray(lead.rmId)
        ? lead.rmId
        : lead.rmId
          ? [lead.rmId]
          : [],
      leadId: lead._id,
      address: [
        {
          ...initialJeweller.address[0],
          address1: lead.address1 || lead.city || "",
          Area: lead.area || "",
          city: lead.city || "",
          state: lead.state || "",
          pincode: lead.pincode || "",
        },
      ],
    };
    setFormData({ data: { enrichedJewellers: [prefilled] } });
    setIsEditMode(false);
    setEditId(null);
    setNewComment("");
    resetSubscriptionForm("custom");
    setOpen(true);
  };

  useEffect(() => {
    if (!location.state?.openJewellerForm || !location.state?.lead) return;
    openCreateFromLead(location.state.lead);
  }, [location.state]);

  const handleOpenDialog = () => {
    setFormData({
      data: {
        enrichedJewellers: [JSON.parse(JSON.stringify(initialJeweller))], // deep clone
      },
    });
    setIsEditMode(false);
    setEditId(null);
    setNewComment("");
    resetSubscriptionForm();
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setFormData({
      data: {
        enrichedJewellers: [initialJeweller],
      },
    });
    setOpen(false);
    setIsEditMode(false);
    setEditId(null);
    setNewComment("");
    resetSubscriptionForm();
    if (fromLead) {
      navigate(-1);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const jeweller = { ...prev.data.enrichedJewellers[0] };
      if (name.startsWith("directors[0].")) {
        // const key = name.split(".")[1];
        // jeweller.directors[0] = { ...jeweller.directors[0], [key]: value };
      }
      // else if (name.startsWith("signatories[0].")) {
      //   const key = name.split(".")[1];
      //   jeweller.signatories[0] = { ...jeweller.signatories[0], [key]: value };
      // }
      else if (name.startsWith("address[0].")) {
        const key = name.split(".")[1];
        jeweller.address[0] = { ...jeweller.address[0], [key]: value };

        if (key === "pincode" && /^\d{6}$/.test(value)) {
          fetchCityFromPincode(value);
        }
      } else {
        jeweller[name] = value;
      }
      return {
        ...prev,
        data: {
          enrichedJewellers: [jeweller],
        },
      };
    });
  };

  const fetchCityFromPincode = async (pincode) => {
    try {
      const res = await fetch(
        `https://api.postalpincode.in/pincode/${pincode}`,
      );
      const data = await res.json();

      if (data[0]?.Status === "Success" && data[0]?.PostOffice?.length > 0) {
        const city = data[0].PostOffice[0].District;
        const state = data[0].PostOffice[0].State;

        setFormData((prev) => {
          const jeweller = { ...prev.data.enrichedJewellers[0] };
          jeweller.address[0] = {
            ...jeweller.address[0],
            pincode,
            city: city || jeweller.address[0].city,
            state: state || jeweller.address[0].state,
          };
          return {
            ...prev,
            data: { enrichedJewellers: [jeweller] },
          };
        });
      }
    } catch (error) {
      console.error("Error fetching city/state from pincode:", error);
    }
  };

  const handleAddJeweller = () => {
    const jewellerData = formData?.data?.enrichedJewellers?.[0];
    if (!jewellerData?.countryCode) {
      return toast.error("country Code is required");
    }

    if (!jewellerData?.jewellerName?.trim())
      return toast.error("Jeweller Name is required");
    if (!jewellerData?.email?.trim())
      return toast.error("Jeweller Email is required");
    const phone = jewellerData?.phone?.trim();

    if (!phone) {
      toast.error("Phone number is required");
      return;
    }

    if (phone.length !== selectedPhoneLength) {
      toast.error(`Phone number must be exactly ${selectedPhoneLength} digits`);
      return;
    }

    // if (!/^[6-9]\d{9}$/.test(phone)) {
    //   toast.error("Enter valid Phone Number");
    //   return;
    // }
    if (!jewellerData?.countryCode)
      return toast.error("Country Code is required");
    if (!jewellerData?.package_name?.trim())
      return toast.error("Package Name (Android) is required");

    const addr = jewellerData.address[0];
    if (!addr?.address1?.trim())
      return toast.error("Address Line 1 is required");
    if (!addr?.city?.trim()) return toast.error("City is required");
    // if (!addr?.pincode?.trim()) return toast.error("Pincode is required");
    if (addr?.pincode?.trim() && !/^\d{5,10}$/.test(addr.pincode)) {
      return toast.error("Pincode must be between 5 and 10 digits");
    }
    if (!addr?.state?.trim()) return toast.error("State is required");
    if (!addr?.gst?.trim()) return toast.error("GST Number is required");
    // const director = jewellerData.directors[0];
    // if (!director?.name?.trim())
    //   return toast.error("Director Name is required");
    // // if (!director?.email?.trim())
    // //   return toast.error("Director Email is required");
    // const directorPhone = director?.phone?.trim();

    // if (!directorPhone) {
    //   toast.error("Director Phone is required");
    //   return;
    // }

    // if (!/^\d{10}$/.test(directorPhone)) {
    //   toast.error("Director Phone must be exactly 10 digits");
    //   return;
    // }

    // if (!/^[6-9]\d{9}$/.test(directorPhone)) {
    //   toast.error("Enter valid Director Phone Number");
    //   return;
    // }

    //   const signatory = jewellerData.signatories[0];
    //   if (!signatory?.name?.trim())
    //     return toast.error("Signatory Name is required");
    //   if (!signatory?.email?.trim())
    //     return toast.error("Signatory Email is required");
    // const signatoryPhone = signatory?.phone?.trim();

    // if (!signatoryPhone) {
    //   toast.error("Signatory Phone is required");
    //   return;
    // }

    // if (!/^\d{10}$/.test(signatoryPhone)) {
    //   toast.error("Signatory Phone must be exactly 10 digits");
    //   return;
    // }

    // if (!/^[6-9]\d{9}$/.test(signatoryPhone)) {
    //   toast.error("Enter valid Signatory Phone Number");
    //   return;
    // }
    // Internal uniqueness (Email)
    // if (jewellerData.email === director.email)
    //   return toast.error("Jeweller Email must not match Director Email");
    // if (jewellerData.email === signatory.email)
    //   return toast.error("Jeweller Email must not match Signatory Email");
    // if (director.email === signatory.email)
    //   return toast.error("Director Email must not match Signatory Email");

    //  Internal uniqueness (Phone)
    // if (jewellerData.phone === director.phone)
    //   return toast.error("Jeweller Phone must not match Director Phone");
    // if (jewellerData.phone === signatory.phone)
    //   return toast.error("Jeweller Phone must not match Signatory Phone");
    // if (director.phone === signatory.phone)
    //   return toast.error("Director Phone must not match Signatory Phone");

    //  External uniqueness checks — helper functions
    // const emailAlreadyExistsInList = (email) =>
    //   jewellerList?.some(
    //     (j) =>
    //       (j.email === email || j.directors?.some((d) => d.email === email)) &&
    //       // || j.signatories?.some((s) => s.email === email)
    //       j._id !== editId
    //   );

    const phoneAlreadyExistsInList = (phone) =>
      jewellerList?.some(
        (j) =>
          (j.phone === phone || j.directors?.some((d) => d.phone === phone)) &&
          // || j.signatories?.some((s) => s.phone === phone)
          j._id !== editId,
      );

    // External uniqueness (Email)
    // if (emailAlreadyExistsInList(jewellerData.email))
    //   return toast.error("Jeweller Email already exists in another record");
    // if (emailAlreadyExistsInList(director.email))
    //   return toast.error("Director Email already exists in another record");
    // if (emailAlreadyExistsInList(signatory.email))
    //   return toast.error("Signatory Email already exists in another record");

    //  External uniqueness (Phone)
    // if (phoneAlreadyExistsInList(jewellerData.phone))
    //   return toast.error("Jeweller Phone already exists in another record");
    // if (phoneAlreadyExistsInList(director.phone))
    //   return toast.error("Director Phone already exists in another record");
    // if (phoneAlreadyExistsInList(signatory.phone))
    //   return toast.error("Signatory Phone already exists in another record");
    //  Helper – check uniqueness by field (package_name = Android, package_name_ios = iOS)
    const packageAlreadyExistsInList = (packageName, field = "package_name") =>
      jewellerList?.some((j) => {
        const existing = (j[field] || "")?.trim().toLowerCase();
        return (
          existing &&
          existing === packageName?.trim().toLowerCase() &&
          j._id !== editId
        );
      });

    //  External uniqueness (Package Name Android, Package Name iOS)
    if (packageAlreadyExistsInList(jewellerData.package_name, "package_name"))
      return toast.error(
        "Package Name (Android) already exists in another record",
      );
    if (
      jewellerData.package_name_ios?.trim() &&
      packageAlreadyExistsInList(
        jewellerData.package_name_ios,
        "package_name_ios",
      )
    )
      return toast.error("Package Name (iOS) already exists in another record");
    //  Submit — keep existing payload; add comment only if the user typed one.
    // Do not send the old comment array. Each request appends a new item.
    const { comment: _ignoredComment, ...jewellerPayload } = jewellerData;
    const trimmedComment = newComment.trim();
    if (trimmedComment) {
      jewellerPayload.comment = trimmedComment;
    }

    if (!isEditMode) {
      if (!Array.isArray(jewellerData.RM) || jewellerData.RM.length === 0) {
        return toast.error("RM is required");
      }
      const allowedValidity = Object.values(subscriptionFrequency);
      if (subscriptionMode === "existing") {
        if (!selectedPlanId) {
          return toast.error("Select a subscription plan");
        }
        jewellerPayload.subscription = {
          mode: "existing",
          planId: selectedPlanId,
        };
      } else {
        const amount = Number(customPlan.amount);
        const planName = `${jewellerData.jewellerName.trim()} plan`;
        if (!planName.trim()) {
          return toast.error("Custom plan name is required");
        }
        if (!(amount > 0)) {
          return toast.error("Plan price is required");
        }
        if (!allowedValidity.includes(customPlan.validity)) {
          return toast.error("Select a valid plan validity");
        }
        const missingBenefit = (customPlan.benefits || []).find(
          (item) => item.restricted && !(Number(item.value) > 0),
        );
        if (missingBenefit) {
          return toast.error(`Enter a limit for ${missingBenefit.label}`);
        }
        jewellerPayload.subscription = {
          mode: "custom",
          planName,
          amount,
          validity: customPlan.validity,
          onBoardingPlan: false,
          features: customPlan.features,
          benefits: toBenefitPayload(customPlan.benefits),
          type: "Custom",
        };
      }

      const paidNow = Number(paidAmount);
      const tdsValue = tdsAmount === "" ? 0 : Number(tdsAmount);
      if (String(paidAmount).trim() === "" || Number.isNaN(paidNow) || paidNow < 0) {
        return toast.error("Amount paid now is required");
      }
      if (Number.isNaN(tdsValue) || tdsValue < 0) {
        return toast.error("TDS must be 0 or more");
      }
      if (couponCode.trim() && !couponInfo?.code) {
        return toast.error("Verify the coupon or clear it");
      }
      jewellerPayload.JewellerAppSubscription = {
        amount: paidNow,
        coupon: couponInfo?.code || "",
        discountAmount: Number(discountAmount || 0),
        payableAmount: Number(payableBeforeGst || 0),
        tds: tdsValue,
      };
    }

    if (isEditMode && editId) {
      dispatch(editJewellerRequest({ _id: editId, ...jewellerPayload }));
    } else {
      dispatch(createJewellerRequest(jewellerPayload));
    }

    handleCloseDialog();
  };

  useEffect(() => {
    const selected = formData?.data?.enrichedJewellers?.[0];
    const countryId = selected?.countryCode;
    if (!countryId || activeCountries.length === 0) return;

    const countryKey =
      countryId && typeof countryId === "object"
        ? countryId._id || countryId.countryCode
        : countryId;

    const matchedActiveCountry = activeCountries.find(
      (a) => a._id === countryKey || a.countryCode === countryKey,
    );

    if (!matchedActiveCountry) return;

    const states = Array.isArray(matchedActiveCountry.states)
      ? matchedActiveCountry.states
      : [];
    const selectedState = selected?.address?.[0]?.state;
    setFilteredStates(
      selectedState && !states.includes(selectedState)
        ? [selectedState, ...states]
        : states,
    );
    setSelectedPhoneLength(matchedActiveCountry.phoneLength || 10);

    const matchedFullCountry = allCountries.find(
      (c) => c.countryCode === matchedActiveCountry.countryCode,
    );

    setSelectedDialCode(
      matchedActiveCountry.dialCode || matchedFullCountry?.dialCode || "+91",
    );
  }, [formData?.data?.enrichedJewellers?.[0]?.countryCode, activeCountries]);

  const handleEditClick = (jeweller) => {
    const fullData = jeweller?.fullData || {};
    const { comment: _commentHistory, ...fullDataWithoutComments } = fullData;
    setNewComment("");
    const countryObj = Array.isArray(fullData.countryCode)
      ? fullData.countryCode[0]
      : null;
    const countryId = countryObj?._id || "";
    const matchedActiveCountry = activeCountries.find(
      (a) => a._id === countryId,
    );
    const matchedFullCountry = allCountries.find(
      (c) => c.countryCode === matchedActiveCountry?.countryCode,
    );
    if (matchedActiveCountry) {
      setFilteredStates(matchedActiveCountry.states || []);
      setSelectedPhoneLength(matchedActiveCountry.phoneLength || 10);
      setSelectedDialCode(
        matchedActiveCountry.dialCode || matchedFullCountry?.dialCode || "+91",
      );
    }

    const enrichedData = {
      ...initialJeweller,
      ...fullDataWithoutComments,
      countryCode: countryId,
      package_name: fullData.package_name ?? "",
      package_name_ios: fullData.package_name_ios ?? "",

      RM: Array.isArray(fullData.RM) ? fullData.RM.map((rm) => rm._id) : [],

      address:
        Array.isArray(fullData.address) && fullData.address.length > 0
          ? [{ ...initialJeweller.address[0], ...fullData.address[0] }]
          : [
              {
                ...initialJeweller.address[0],
                address1: fullData.address1 || "",
                address2: fullData.address2 || "",
                address3: fullData.address3 || "",
                Area: fullData.Area || "",
                city: fullData.city || "",
                pincode: fullData.pincode || "",
                state: fullData.state || "",
              },
            ],

      // directors:
      //   Array.isArray(fullData.directors) && fullData.directors.length > 0
      //     ? [{ ...initialJeweller.directors[0], ...fullData.directors[0] }]
      //     : [...initialJeweller.directors],

      // signatories: Array.isArray(fullData.signatories) && fullData.signatories.length > 0
      //   ? [{ ...initialJeweller.signatories[0], ...fullData.signatories[0] }]
      //   : [...initialJeweller.signatories],
    };

    setFormData({ data: { enrichedJewellers: [enrichedData] } });
    setEditId(jeweller._id);
    setIsEditMode(true);
    setOpen(true);
  };

  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (e) {
        console.error("Invalid permissions JSON", e);
      }
    }
  }, []);

  const canCreateJeweller = canShowPermission(
    permissions,
    "jeweller",
    "create",
  );

  const jewellerData = formData?.data?.enrichedJewellers?.[0];
  const selectedExistingPlan = (
    Array.isArray(subscriptionPlans) ? subscriptionPlans : []
  ).find((plan) => plan._id === selectedPlanId);
  const planPrice =
    subscriptionMode === "existing"
      ? Number(selectedExistingPlan?.amount || 0)
      : Number(customPlan.amount || 0);
  const discountAmount = (() => {
    if (!couponInfo?.code || !(planPrice > 0)) return 0;
    const couponValue = Number(couponInfo.value || 0);
    const isPercent =
      couponInfo.calculationType === CalculationType.Percentage ||
      couponInfo.calculationType === 1;
    const discount = isPercent
      ? Math.round((planPrice * couponValue) / 100)
      : couponValue;
    return Math.min(Math.max(Number(discount) || 0, 0), planPrice);
  })();
  const payableBeforeGst = Math.max(planPrice - discountAmount, 0);
  const payableWithGst = Number((payableBeforeGst * 1.18).toFixed(2));
  const hasFilledValue = (value) => {
    if (Array.isArray(value)) return value.length > 0;
    return value != null && String(value).trim() !== "";
  };
  const lockFilled = (value) => fromLead && hasFilledValue(value);

  return (
    <Box sx={{ width: "98%" }}>
      {!fromLead && (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          mt: { xs: 10, md: 10 },
          mb: { xs: 2, md: 2 },
          background: "#fff",
          borderRadius: "3px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Box sx={{ justifyContent: "space-between", display: "flex", p: 2 }}>
          <Typography
            fontFamily={"Aeonik"}
            sx={{ fontSize: "24px", fontWeight: 700 }}
          >
            Jeweller List
          </Typography>
          {/* {canCreateJeweller && (
            <Button
              variant="contained"
              color="secondary"
              startIcon={<AddIcon />}
              sx={{
                textTransform: "none",
                background:
                  "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
                fontFamily: "inherit",
              }}
              onClick={handleOpenDialog}
            >
              New Jeweller
            </Button>
          )} */}
        </Box>
        <CardContent sx={{ width: "100%" }}>
          <CreateJwellerTable onEdit={handleEditClick} />
        </CardContent>
      </Box>
      )}

      <JewellerFormFrame
        pageMode={fromLead}
        open={open}
        onClose={handleCloseDialog}
      >
        <Box sx={{ overflowY: "auto" }}>
          <Box
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              cursor: "pointer",
              background: "#E2E2EA",
              borderRadius: "50%",
              width: 26,
              height: 26,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#646464",
            }}
            onClick={handleCloseDialog}
          >
            <RxCross2 />
          </Box>
        </Box>

        {/* Basic Info */}
        <Typography
          fontWeight={700}
          fontSize={24}
          p={2}
          sx={{
            background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
            color: "#fff",
          }}
          fontFamily={"Aeonik"}
        >
          {isEditMode ? "Company Details" : "Create Jeweller"}
        </Typography>
        <Divider />
        <Box sx={sectionCardSx}>
          {!isEditMode && (
            <SectionHeading
              step="1"
              title="Jeweller details"
              description="Company, contact, address, and package information."
            />
          )}
          <Grid container spacing={2}>
            {[
              { name: "jewellerName", label: "Company Name" },
              { name: "email", label: "Company Email ID", type: "email" },
            ].map((field, i) => (
              <Grid item xs={12} sm={6} md={4} key={i}>
                <TextField
                  sx={{
                    width: "350px",
                  }}
                  fullWidth
                  size="small"
                  {...field}
                  label={
                    <>
                      {field.label} <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  value={jewellerData[field.name]}
                  onChange={handleChange}
                  disabled={lockFilled(jewellerData[field.name])}
                />
              </Grid>
            ))}

            {/* Country Code Dropdown */}
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel id="country-code-label">
                  Country <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Select
                  labelId="country-code-label"
                  name="countryCode"
                  value={
                    // show matched countryCode (for visible name in dropdown)
                    (() => {
                      const matchedActive = activeCountries.find(
                        (a) => a._id === jewellerData.countryCode,
                      );
                      return matchedActive ? matchedActive.countryCode : "";
                    })()
                  }
                  onChange={(e) => {
                    const selectedCountryCode = e.target.value;

                    // find active country that matches selected code
                    const matchedActive = activeCountries.find(
                      (a) => a.countryCode === selectedCountryCode,
                    );

                    if (!matchedActive) {
                      toast.error("Selected country is not active");
                      return;
                    }

                    // find from full list for dialCode fallback
                    const selectedFullCountry = allCountries.find(
                      (c) => c.countryCode === selectedCountryCode,
                    );

                    setSelectedPhoneLength(matchedActive.phoneLength || 10);
                    setSelectedDialCode(
                      matchedActive.dialCode ||
                        selectedFullCountry?.dialCode ||
                        "+91",
                    );
                    setFilteredStates(matchedActive.states || []);

                    // save only _id in jeweller.countryCode (for backend)
                    setFormData((prev) => {
                      const jeweller = { ...prev.data.enrichedJewellers[0] };
                      jeweller.countryCode = matchedActive._id;
                      return {
                        ...prev,
                        data: { enrichedJewellers: [jeweller] },
                      };
                    });
                  }}
                  sx={{ width: "350px" }}
                  disabled={lockFilled(jewellerData.countryCode)}
                >
                  {allCountries.map((country) => {
                    // only show if this country exists in activeCountries
                    const isActive = activeCountries.some(
                      (a) => a.countryCode === country.countryCode,
                    );
                    return (
                      <MenuItem
                        key={country.countryCode}
                        value={country.countryCode}
                        disabled={!isActive}
                      >
                        {`${country.countryName} (${country.countryCode})`}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>

            {/* Company Phone (shows selected country code) */}
            <Grid item xs={12} sm={6} md={4}>
              <Box
                sx={{ display: "flex", alignItems: "center", width: "350px" }}
              >
                {/* Dial code display only (not editable) */}
                <TextField
                  sx={{ flexShrink: 0, width: "80px", mr: 1 }}
                  size="small"
                  value={selectedDialCode}
                  disabled
                />

                {/* Actual phone number input */}
                <TextField
                  fullWidth
                  size="small"
                  name="phone"
                  label={
                    <>
                      Company Phone <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  type="tel"
                  placeholder={`Enter ${selectedPhoneLength}-digit phone number`}
                  value={jewellerData.phone || ""}
                  disabled={lockFilled(jewellerData.phone)}
                   onChange={(e) => {
                    const raw = e.target.value.replace(/\D/g, "");
                    const dialCode = selectedDialCode.replace("+", "");

                    let number = raw;
                    if (
                      raw.length > selectedPhoneLength &&
                      raw.startsWith(dialCode)
                    ) {
                      number = raw.slice(dialCode.length);
                    }
                    if (number.length <= selectedPhoneLength) {
                      handleChange({
                        target: { name: "phone", value: number },
                      });
                    }
                  }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel id="rm-label">
                  RM <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Select
                  labelId="rm-label"
                  name="RM"
                  multiple
                  value={jewellerData.RM || []}
                  disabled={lockFilled(jewellerData.RM)}
                  sx={{ width: "350px" }}
                  onChange={(e) =>
                    handleChange({
                      target: { name: "RM", value: e.target.value },
                    })
                  }
                  renderValue={(selected) =>
                    selected
                      .map(
                        (id) =>
                          instalaxmiUsers.find((user) => user._id === id)
                            ?.name || "",
                      )
                      .join(", ")
                  }
                >
                  {instalaxmiUsers?.map((user) => (
                    <MenuItem key={user._id} value={user._id}>
                      {user.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          {/* Address Fields */}
          <Grid container spacing={2} mt={2}>
            {["address1", "address2", "address3"].map((field, idx) => (
              <Grid key={idx} item xs={12} sm={6} md={4}>
                <TextField
                  sx={{
                    width: "350px",
                  }}
                  label={
                    <>
                      Address Line {idx + 1}
                      {idx === 0 && <span style={{ color: "red" }}> *</span>}
                    </>
                  }
                  name={`address[0].${field}`}
                  value={jewellerData.address[0][field]}
                  onChange={handleChange}
                  disabled={field === "address1" && lockFilled(jewellerData.address[0][field])}
                  fullWidth
                  size="small"
                />
              </Grid>
            ))}
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                sx={{
                  width: "350px",
                }}
                label={
                  <>
                    Area <span style={{ color: "red" }}>*</span>
                  </>
                }
                name="address[0].Area"
                value={jewellerData.address[0].Area}
                onChange={handleChange}
                disabled={lockFilled(jewellerData.address[0].Area)}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel id="state-label">
                  State <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Select
                  sx={{
                    width: "350px",
                  }}
                  label={
                    <>
                      State <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  name="address[0].state"
                  value={jewellerData.address[0].state}
                  onChange={handleChange}
                  disabled={lockFilled(jewellerData.address[0].state)}
                >
                  {filteredStates.length > 0 ? (
                    filteredStates.map((state) => (
                      <MenuItem key={state} value={state}>
                        {state}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem value="">No states available</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                sx={{
                  width: "350px",
                }}
                label={
                  <>
                    City <span style={{ color: "red" }}>*</span>
                  </>
                }
                name="address[0].city"
                value={jewellerData.address[0].city}
                onChange={handleChange}
                disabled={lockFilled(jewellerData.address[0].city)}
                fullWidth
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                sx={{
                  width: "350px",
                }}
                label={
                  <>
                    Pincode <span style={{ color: "red" }}></span>
                  </>
                }
                name="address[0].pincode"
                value={jewellerData.address[0].pincode}
                onChange={handleChange}
                disabled={lockFilled(jewellerData.address[0].pincode)}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                sx={{ width: "350px" }}
                label={
                  <>
                    GST Number <span style={{ color: "red" }}>*</span>
                  </>
                }
                name="address[0].gst"
                value={jewellerData.address[0].gst || ""}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                sx={{ width: "350px" }}
                label={
                  <>
                    CIN Number
                  </>
                }
                name="address[0].cin"
                value={jewellerData.address[0].cin || ""}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                sx={{
                  width: "350px",
                }}
                name="package_name"
                label={
                  <>
                    Package Name (Android){" "}
                    <span style={{ color: "red" }}>*</span>
                  </>
                }
                value={jewellerData.package_name ?? ""}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                sx={{
                  width: "350px",
                }}
                name="package_name_ios"
                label="Package Name (iOS)"
                placeholder="Optional"
                value={jewellerData.package_name_ios ?? ""}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                sx={{
                  width: "350px",
                }}
                multiline
                minRows={3}
                size="small"
                label={isEditMode ? "Add Comment" : "Comment"}
                placeholder="Add a comment (optional)"
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
              />
            </Grid>
          </Grid>
        </Box>

        {/* Director */}
        {/* <Box sx={{ p: 2, mt: 1, background: "#fff", borderRadius: "16px" }}>
          <Typography fontWeight={700} fontSize={24} mb={2} fontFamily="Aeonik">
            Director Details
          </Typography>
          <Grid container spacing={2}>
            {["name", "email", "phone"].map((field, idx) => (
              <Grid key={idx} item xs={12} sm={6} md={4}>
                <TextField
                  sx={{
                    width: "350px",
                  }}
                  label={
                    <>
                      {field === "email"
                        ? "Director Email ID"
                        : field === "phone"
                        ? "Director Phone"
                        : "Director Name"}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  name={`directors[0].${field}`}
                  value={jewellerData.directors[0][field]}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  type={
                    field === "email"
                      ? "email"
                      : field === "phone"
                      ? "tel"
                      : "text"
                  }
                  placeholder={
                    field === "phone"
                      ? "+1 (416) 555-1212"
                      : field === "email"
                      ? "example@mail.com"
                      : "Enter full name"
                  }
                />
              </Grid>
            ))}
          </Grid>
        </Box>*/}

        {/* Signatory
        <Box sx={{ p: 2, mt: 1, background: "#fff", borderRadius: "16px" }}>
          <Typography fontWeight={700} fontSize={24} mb={2} fontFamily="Aeonik">
            Signator
          </Typography>
          <Grid container spacing={2}>
            {["name", "email", "phone"].map((field, idx) => (
              <Grid key={idx} item xs={12} sm={6} md={4}>
                <TextField
                 sx={{
                 width: "350px" 
                }}
                  label={
                    <>
                      {field === "email"
                        ? "Email ID"
                        : field === "phone"
                        ? "Primary Phone"
                        : "Name"}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  name={`signatories[0].${field}`}
                  value={jewellerData.signatories[0][field]}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  type={
                    field === "email"
                      ? "email"
                      : field === "phone"
                      ? "tel"
                      : "text"
                  }
                  placeholder={
                    field === "phone"
                      ? "+1 (416) 555-1212"
                      : field === "email"
                      ? "example@mail.com"
                      : "Enter full name"
                  }
                />
              </Grid>
            ))}
          </Grid>
        </Box> */}

        {!isEditMode && (
          <>
            <Box sx={sectionCardSx}>
              <SectionHeading
                step="2"
                title="Subscription plan"
                description="Choose an existing plan, or build a custom plan. The server sets the start time to now and the end time from the plan validity."
              />
              <RadioGroup
                row
                value={subscriptionMode}
                onChange={(e) => {
                  setSubscriptionMode(e.target.value);
                  setCouponCode("");
                  setCouponInfo(null);
                  setDidVerifyCoupon(false);
                  dispatch(clearCouponInfo());
                  dispatch(clearCouponError());
                }}
              >
                <FormControlLabel
                  value="existing"
                  control={<Radio />}
                  label="Existing plan"
                />
                <FormControlLabel
                  value="custom"
                  control={<Radio />}
                  label="Custom plan"
                />
              </RadioGroup>
              {subscriptionMode === "existing" ? (
                <FormControl fullWidth size="small" sx={{ mt: 2, maxWidth: 480 }}>
                  <InputLabel id="subscription-plan-label">
                    Subscription plan <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="subscription-plan-label"
                    label="Subscription plan *"
                    value={selectedPlanId}
                    onChange={(e) => setSelectedPlanId(e.target.value)}
                  >
                    {(Array.isArray(subscriptionPlans) ? subscriptionPlans : []).map(
                      (plan) => (
                        <MenuItem key={plan._id} value={plan._id}>
                          {`${plan.planName} — ${formatInr(plan.amount)} / ${
                            VALIDITY_LABELS[plan.validity] || plan.validity || "-"
                          }`}
                        </MenuItem>
                      ),
                    )}
                  </Select>
                </FormControl>
              ) : (
                <Box sx={{ mt: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Plan name"
                        value={
                          jewellerData?.jewellerName?.trim()
                            ? `${jewellerData.jewellerName.trim()} plan`
                            : ""
                        }
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <TextField
                        fullWidth
                        size="small"
                        type="number"
                        label={
                          <>
                            Plan price <span style={{ color: "red" }}>*</span>
                          </>
                        }
                        value={customPlan.amount}
                        inputProps={{ min: 0 }}
                        onChange={(e) => {
                          const next = e.target.value;
                          if (next !== "" && Number(next) < 0) return;
                          setCustomPlan((prev) => ({ ...prev, amount: next }));
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="custom-validity-label">
                          Validity <span style={{ color: "red" }}>*</span>
                        </InputLabel>
                        <Select
                          labelId="custom-validity-label"
                          label="Validity *"
                          value={customPlan.validity}
                          onChange={(e) =>
                            setCustomPlan((prev) => ({
                              ...prev,
                              validity: e.target.value,
                            }))
                          }
                        >
                          {Object.values(subscriptionFrequency).map((option) => (
                            <MenuItem key={option} value={option}>
                              {VALIDITY_LABELS[option] || option}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Typography fontWeight={600} mt={2} mb={1}>
                    Features
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      px: 1,
                      py: 0.5,
                      border: "1px solid #F0F0F5",
                      borderRadius: "8px",
                    }}
                  >
                    {featureChoices.length === 0 ? (
                      <Typography variant="body2" color="text.secondary" sx={{ p: 1 }}>
                        No features configured.
                      </Typography>
                    ) : (
                      featureChoices.map((feature) => (
                        <FormControlLabel
                          key={feature}
                          control={
                            <Checkbox
                              checked={customPlan.features.includes(feature)}
                              onChange={(e) =>
                                setCustomPlan((prev) => ({
                                  ...prev,
                                  features: e.target.checked
                                    ? [...prev.features, feature]
                                    : prev.features.filter((item) => item !== feature),
                                }))
                              }
                            />
                          }
                          label={feature}
                        />
                      ))
                    )}
                  </Box>
                  <Typography fontWeight={600} mt={2} mb={1}>
                    Benefits
                  </Typography>
                  {customPlan.benefits.map((field) => (
                    <Box
                      key={field.key}
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 2,
                        alignItems: "center",
                        py: 1.25,
                        borderBottom: "1px solid #F0F0F5",
                      }}
                    >
                      <Box sx={{ flex: "1 1 240px" }}>
                        <Typography fontWeight={600} fontSize={14}>
                          {field.label}
                        </Typography>
                        <FormControlLabel
                          sx={{ ml: 0 }}
                          control={
                            <Switch
                              checked={!!field.restricted}
                              onChange={(e) =>
                                setCustomPlan((prev) => ({
                                  ...prev,
                                  benefits: prev.benefits.map((item) =>
                                    item.key === field.key
                                      ? {
                                          ...item,
                                          restricted: e.target.checked,
                                          value: e.target.checked ? item.value : 0,
                                        }
                                      : item,
                                  ),
                                }))
                              }
                            />
                          }
                          label={field.restricted ? "Restricted" : "Unlimited"}
                        />
                      </Box>
                      <TextField
                        size="small"
                        type="number"
                        label="Limit"
                        value={field.restricted ? field.value : 0}
                        disabled={!field.restricted}
                        inputProps={{ min: 0 }}
                        sx={{ width: { xs: "100%", sm: 200 } }}
                        onChange={(e) => {
                          const next = e.target.value;
                          if (next !== "" && Number(next) < 0) return;
                          setCustomPlan((prev) => ({
                            ...prev,
                            benefits: prev.benefits.map((item) =>
                              item.key === field.key ? { ...item, value: next } : item,
                            ),
                          }));
                        }}
                      />
                    </Box>
                  ))}
                </Box>
              )}
            </Box>

            <Box sx={{ ...sectionCardSx, mb: 1 }}>
              <SectionHeading
                step="3"
                title="Jeweller subscription"
                description="Plan price is the subscription amount. Amount paid now is what was collected today. Payable shown here includes 18% GST."
              />
              <Grid container spacing={2} sx={{ mb: 2 }}>
                {[
                  {
                    label: "Plan price",
                    value: formatInr(planPrice),
                    hint: "Subscription amount",
                  },
                  {
                    label: "Discount",
                    value: formatInr(discountAmount),
                    hint: couponInfo?.code ? `Coupon ${couponInfo.code}` : "No coupon",
                  },
                  {
                    label: "Payable",
                    value: formatInr(payableWithGst),
                    hint: "Includes 18% GST",
                  },
                ].map((item) => (
                  <Grid item xs={12} sm={4} key={item.label}>
                    <Box
                      sx={{
                        p: 1.5,
                        height: "100%",
                        borderRadius: "10px",
                        background: "#F7F5FC",
                        border: "1px solid #E7E1F5",
                      }}
                    >
                      <Typography variant="body2" color="text.secondary">
                        {item.label}
                      </Typography>
                      <Typography fontWeight={700} fontSize={18} mt={0.5}>
                        {item.value}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {item.hint}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    label={
                      <>
                        Amount paid now <span style={{ color: "red" }}>*</span>
                      </>
                    }
                    value={paidAmount}
                    inputProps={{ min: 0 }}
                    onChange={(e) => {
                      const next = e.target.value;
                      if (next !== "" && Number(next) < 0) return;
                      setPaidAmount(next);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    label="TDS"
                    value={tdsAmount}
                    inputProps={{ min: 0 }}
                    onChange={(e) => {
                      const next = e.target.value;
                      if (next !== "" && Number(next) < 0) return;
                      setTdsAmount(next);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Coupon"
                      value={couponCode}
                      onChange={(e) => {
                        setCouponCode(e.target.value);
                        setCouponInfo(null);
                      }}
                    />
                    <Button
                      variant="outlined"
                      onClick={() => {
                        if (!couponCode.trim()) {
                          toast.error("Enter a coupon code");
                          return;
                        }
                        if (!(planPrice > 0)) {
                          toast.error("Set the plan price before applying a coupon");
                          return;
                        }
                        setDidVerifyCoupon(true);
                        dispatch(getApplicableCouponsRequest(couponCode.trim()));
                      }}
                      sx={{ textTransform: "none", minWidth: 120 }}
                    >
                      Verify
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </>
        )}

        <DialogActions>
          {fromLead && (
            <Button
              onClick={handleCloseDialog}
              sx={{ textTransform: "none" }}
            >
              Back
            </Button>
          )}
          <Button
            variant="contained"
            onClick={handleAddJeweller}
            sx={{
              background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
              px: 6,
              textTransform: "none",
            }}
          >
            {isEditMode ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </JewellerFormFrame>
    </Box>
  );
};

export default CreateJwellerList;
